(function WebCustomerCreateForm($, HE)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		$('.show-pass').on('click', function showPass() {
			var sibling = $(this).siblings('span').find('input');
			var type    = sibling.attr('type');

			if (type === 'password') {
				sibling.attr('type', 'text');
				$(this).find('i').removeClass('fa-eye');
				$(this).find('i').addClass('fa-eye-slash');

			} else {
				sibling.attr('type', 'password');
				$(this).find('i').removeClass('fa-eye-slash');
				$(this).find('i').addClass('fa-eye');
			}
		});

		$('.captcha-submit').prop("disabled", true);
	});

	HE.WebCustomerCreateForm = WebCustomerCreateForm;
}(jQuery, window.HE || {}));